import { render } from "./SimpleTableForIcon.vue?vue&type=template&id=3be66060&scoped=true"
import script from "./SimpleTableForIcon.vue?vue&type=script&lang=ts"
export * from "./SimpleTableForIcon.vue?vue&type=script&lang=ts"

import "./SimpleTableForIcon.vue?vue&type=style&index=0&id=3be66060&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3be66060"

export default script